package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Formation
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.FormationState
import org.jetbrains.compose.web.css.px

@Composable
fun FormationAccordionContent(
    onComplete: (String) -> Unit,
    onAddFormationAndClose: (String) -> Unit
) {

    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val formationsFromVM = cvUiState.data.formations

    LaunchedEffect(Unit) {
        if (formationsFromVM.isEmpty()) {
            cvViewModel.updateFormation(0, Formation(label = "", school = "", city = "", started = "", ended = "", description = ""))
            cvViewModel.editingFormationId = "formation-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        formationsFromVM.forEachIndexed { index, formation ->
            val tempId = "formation-$index"

            val formationState = remember(formation) {
                FormationState(
                    id = tempId,
                    formation = formation.label,
                    etablissement = formation.school,
                    ville = formation.city,
                    moisDebut = formation.started.split("-").getOrNull(0) ?: "",
                    anneeDebut = formation.started.split("-").getOrNull(1) ?: "",
                    moisFin = formation.ended.split("-").getOrNull(0) ?: "",
                    anneeFin = formation.ended.split("-").getOrNull(1) ?: "",
                    isOngoing = formation.ended == "En cours",
                    description = formation.description
                )
            }

            GenericFormCard(
                item = formationState,
                isEditing = cvViewModel.editingFormationId == tempId,
                onEdit = { cvViewModel.editingFormationId = tempId },
                onDelete = {
                    cvViewModel.deleteFormation(index)
                    if (formationsFromVM.size <= 1) {
                        cvViewModel.updateFormation(0, Formation(label = "", school = "", city = "", started = "", ended = "", description = ""))
                        cvViewModel.editingFormationId = "formation-0"
                    } else {
                        cvViewModel.editingFormationId = null
                    }
                },
                onComplete = {
                    val updatedFormation = Formation(
                        label = formationState.formation,
                        school = formationState.etablissement,
                        city = formationState.ville,
                        started = "${formationState.moisDebut}-${formationState.anneeDebut}",
                        ended = if (formationState.isOngoing) "En cours" else "${formationState.moisFin}-${formationState.anneeFin}",
                        description = formationState.description
                    )
                    cvViewModel.updateFormation(index, updatedFormation)

                    cvViewModel.editingFormationId = null
                },
                getSummary = { f ->
                    if (f.formation.isNotBlank() || f.etablissement.isNotBlank()) {
                        SummaryData(
                            title = f.formation.ifBlank { "[Formation]" },
                            subtitle = f.etablissement.ifBlank { "[Établissement]" }
                        )
                    } else {
                        null
                    }
                },
                getDefaultText = { "[Formation]" },
                formContent = { state, onDel, onComp ->
                    FormationForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter une formation",
            onClick = {
                val nextIndex = formationsFromVM.size
                cvViewModel.updateFormation(nextIndex, Formation(label = "", school = "", city = "", started = "", ended = "", description = ""))
                cvViewModel.editingFormationId = "formation-$nextIndex"
            }
        )
    }
}